import React, { useState, useEffect, useMemo } from "react";
import {
  Alert,
  Modal,
  ModalBody,
  ModalFooter,
  Spinner,
  Label,
  Form,
  Input,
} from "reactstrap";
import * as url from "../../../helpers/url_helper";
import { toast } from "react-toastify";
import Request from "../../../helpers/request";
import { convertLocalDate } from "../../../Utils/configController";
import AirHomeLoader from "../../../components/Common/AirHomeLoader";
import { useFormik } from "formik";
import * as Yup from "yup";
import Select from "react-select";

import $ from "jquery";
import { userSearchApiCall } from "../../../Utils/searchApiCall";
import Mockup from "./Mockup";

// import { ToastContainer, toast } from "react-toastify";

// import { userSearchApiCall } from "../Utils/searchApiCall";
export interface modelType {
  headerTitle: string;
  isTemplateOpen: boolean;
  templateData?: any;
  cancleBtnClick(): void;
}

const SendModal = ({
  isTemplateOpen,
  headerTitle,
  templateData,
  cancleBtnClick,
}: modelType) => {
  const [userData, setUserData] = useState([]);
  const [loading, setLoading] = useState(false);

  const validation = useFormik({
    initialValues: {
      user: "",
      formError: "",
    },
    validationSchema: Yup.object().shape({
      user: Yup.string().required("Please select user "),
    }),
    onSubmit: (values) => {
      sendNotificationApiCall(values);
    },
  });

  const sendNotificationApiCall = (values: any) => {
    setLoading(true);
    const reqObj = {
      userId: values.user.includes("all") ? "all" : values.user,
      templateId: templateData?.id,
    };
    Request.post(url.SEND_NOTIFICATION_TEMPLATE, reqObj)
      .then((res) => {
        toggleNotification();
        toast.success(res.data.msg);
        setLoading(false);
      })
      .catch((err) => {
        validation.setErrors({
          formError: err?.response?.data?.msg,
        });
        setLoading(false);
      });
  };

  const toggleNotification = () => {
    cancleBtnClick();
    validation.resetForm({
      values: {
        user: "",
        formError: "",
      },
      touched: {},
    });
  };
  const userSearch = (e: any) => {
    userSearchApiCall(e, setUserData, 3);
  };

  return (
    <div>
      {loading && <AirHomeLoader />}
      <Modal
        isOpen={isTemplateOpen}
        className="modal-xl"
        toggle={toggleNotification}
        style={{
          backgroundColor: "#F7F7FA",
          borderRadius: "12px",
          padding: "0px",
        }}
      >
        <div className="modal-header justify-content-between">
          <div className="d-flex flex-column align-items-center">
            <h5
              className="modal-title"
              id="staticBackdropLabel"
              style={{ textAlign: "center" }}
            >
              {headerTitle}
            </h5>
          </div>
          <button
            className="btn p-0 d-flex align-items-center"
            style={{
              border: "none",
            }}
            onClick={toggleNotification}
            title="Close"
          >
            <box-icon name="x" size="30px"></box-icon>
          </button>
        </div>
        <div className="d-flex flex-wrap  justify-content-center flex-md-row flex-column gap-3">
          <Form
            style={{ flex: "0 0 48%", width: "100%" }}
            className="form-horizontal"
            onSubmit={(e) => {
              // console.log("call on submit", e);
              e.preventDefault();
              validation.handleSubmit();
              return false;
            }}
          >
            <ModalBody>
              {validation.errors && validation.errors.formError ? (
                <Alert color="danger">{validation.errors.formError}</Alert>
              ) : null}
              <div className="mb-3 ajax-select mt-3 mt-lg-0 select2-container">
                <Label>User</Label>
                <Select
                  name="user"
                  onFocus={() => userSearch("")}
                  value={userData.find(
                    (option: any) => option.value === validation.values.user
                  )}
                  options={userData}
                  onChange={(selectedOption: any) =>
                    validation.setFieldValue("user", selectedOption.value)
                  }
                  onBlur={() => validation.setFieldTouched("user", true)}
                  // invalid={
                  //   assignPremiseValidation.touched.recipientUserId && assignPremiseValidation.errors.recipientUserId ? true : false
                  // }
                  // className={cx({ 'is-invalid': invalid })}
                  onInputChange={(e) => userSearch(e)}
                  styles={customStyles}
                />
                {validation.touched.user && validation.errors.user ? (
                  <span className="error">{validation.errors.user}</span>
                ) : null}
              </div>
            </ModalBody>
            <ModalFooter style={{ justifyContent: "center" }}>
              <button className="btn btn-dark" type="submit" disabled={loading}>
                {/* Add */}
                {loading ? "Sanding..." : "Send"}
                {/* {loading ? "Loading..." : isEditable ? "Edit" : "Add"} */}
              </button>
            </ModalFooter>
          </Form>
          <div className="border" style={{ flex: "0 0 48%" }}>
            <Mockup templateData={templateData} />
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default SendModal;
interface CustomStyles {
  menu?: (provider: any) => any;
  control?: (base: any, state: any) => any;
}
export const customStyles: CustomStyles = {
  menu: (provided: any) => ({
    ...provided,
    backgroundColor: "white", // Set background color for the dropdown menu
    border: "1px solid #ccc", // Optional: Add border for clarity
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)", // Optional: Add shadow
  }),
};
